import { DisabledPrompt, NavLink, BrandingStyle } from "bcms-react";
import React from "react";
import { SVGAsset } from "res";
import "./styles.css";

/**
 * @function LoginNavigation
 * @exported true
 * @returns {React.Component}
 * @description The container component for all Login Navigation Items.
 */
export function LoginNavigation(props) {
  return(
    <div className="login-navigation flex-height flex-container flex-horizontal align-bottom">
      <BrandingStyle style={{ "backgroundColor" : "login_nav_bg_mabi23" }}  className="login-items-container flex-container flex-horizontal flex-width space-around">
        <DisabledPrompt>
          <LoginNavigationItem className="register-link" text="Register" icon="PlusPersonIcon" />
        </DisabledPrompt>
        <LoginNavigationItem className="face-id-link" text="Face ID" icon="FaceIDIcon" to="/content/accountSummary" dataPoint="Login_Face_ID" />
        <DisabledPrompt>
          <LoginNavigationItem className="location-link" text="Location" icon="LocationPinIcon" />
        </DisabledPrompt>
        <DisabledPrompt>
          <LoginNavigationItem className="call-us-link" text="Call Us" icon="PhoneIcon" />
        </DisabledPrompt>
      </BrandingStyle>
    </div>
  );
}

/**
 * @function LoginNavigationItem
 * @param {STRING} text - Allows us to set the text of the navigation item.
 * @param {STRING} to - Sets the route of the NavLink.
 * @param {STRING} icon - Sets the icon for the navigation item.
 * @returns {React.Component}
 * @exported false
 * @description This is the individual login navigation item component. It includes text and an icon.
 * @example
 * <LoginNavigationItem text="Location" icon="LocationPinIcon" to="/LocationPage" />
 */
function LoginNavigationItem(props) {
  const text = props.text ?? "[text]";
  const to = props.to ?? "";
  const icon = props.icon ?? "FaceIDIcon";
  const className = props.className ?? "";
  const dataPoint = props.dataPoint ? { "data-point": props.dataPoint } : {};

  return(
    <BrandingStyle style={{ "color" : "nav_link_icon_mabi23", "fill" : "nav_link_icon_mabi23" }}>
    <NavLink to={ to } className={ className }>
      <div className="login-navigation-item flex-width flex-container flex-vertical align-center justify-right">
        <BrandingStyle 
          style={{ "borderColor" : "nav_link_icon_mabi23" }} 
          className="flex-height icon-container flex-container align-center">
          <BrandingStyle 
            style={{ "fill" : "nav_link_icon_mabi23" }} 
            element={<SVGAsset id={icon} 
            className="outlined-icon" { ...dataPoint } />} />
        </BrandingStyle>
        <BrandingStyle 
          style={{ "color" : "nav_link_icon_mabi23" }} 
          className="flex-height link-text" 
          element={<p >{text}</p>} />
      </div>
    </NavLink>
    </BrandingStyle>
  );
}